import { useActiveCountries } from "../queries/countries/useActiveCountries";

export type CountryOptions = {
  onlyAvailable?: boolean;
  allowOverride?: boolean;
  sort?: boolean;
};

export const useCountries = (options?: CountryOptions) => {
  const { data: activeCountries, isLoading } = useActiveCountries();

  const availableCountries = activeCountries?.filter(
    (country) => country?.available
  );

  const countriesUnsorted = options?.onlyAvailable
    ? availableCountries
    : activeCountries;

  const countries =
    options?.sort === true
      ? countriesUnsorted?.sort((a, b) => a.name!.localeCompare(b.name!) || 0)
      : countriesUnsorted;

  const countryFromCode = (code?: string) => {
    if (!code) {
      return undefined;
    }

    return countries?.find((country) => country.code === code);
  };

  return {
    countries,
    countryFromCode,
    isLoading,
  };
};
